import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FlexModule } from "@vp/shared/directives/flex";
import { ContextDisplayModule } from "@vp/shared/pipes/context-display";
import { AddCostPricingPlanModule } from "@vp/tag-manager/ui/add-cost-pricing-plan";
import { AddServiceFeeOverrideModule } from "@vp/tag-manager/ui/add-service-fee-override";
import { EditServiceCostPlanComponent } from "./edit-service-cost-plan.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatToolbarModule,
    MatButtonModule,
    MatTableModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatCheckboxModule,
    AddCostPricingPlanModule,
    AddServiceFeeOverrideModule,
    ContextDisplayModule,
    FlexModule
  ],
  declarations: [EditServiceCostPlanComponent]
})
export class EditServiceCostPlanModule {}
